<script lang="ts" setup>import { toRef as _toRef, ref as _ref, computed as _computed } from 'vue';

import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'

const __$temp_1 = (useRecipientLanding()),
  messageForRecipient = _toRef(__$temp_1, 'messageForRecipient'),
  recipientName = _toRef(__$temp_1, 'recipientName'),
  senderName = _toRef(__$temp_1, 'senderName');

const messageRef = _ref<HTMLDivElement>()
const hasScrollableContent = _computed(() => messageRef.value
  && messageRef.value?.scrollHeight > messageRef.value.clientHeight)
</script>

<template>
  <div
    class="bg-white text-navy flex flex-col py-6 text-left"
    style="height: 360px; width: 269px;"
  >
    <div v-if="recipientName" class="px-6 text-xs">
      To <span class="text-base font-semibold">{{ recipientName }}<span/></span>
    </div>

    <div
      class="w-full relative mt-6 mb-3 px-6"
      :style="{
        background: hasScrollableContent
          ? 'linear-gradient(-180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 90%, rgba(243,249,255,1) 100%)'
          : '',
      }"
    >
      <div ref="messageRef" class="overflow-y-auto -mx-6" style="max-height: 230px;">
        <div
          v-if="messageForRecipient"
          class="whitespace-pre-wrap px-6"
          v-text="messageForRecipient"
        />
      </div>

    </div>

    <div v-if="senderName" class="px-6 text-xs">
      From <span class="text-base font-semibold">{{ senderName }}<span/></span>
    </div>
  </div>
</template>
